
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/profile-views",
      function () {
        return require("private-next-pages/dashboard/profile-views.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/profile-views"])
      });
    }
  